import { AdapterInterface } from '@/common/interfaces';

export const userAdapter: AdapterInterface<any> = {
    adapt: (data: any) => {
        return data;
    },
};
